module.exports = __webpack_public_path__ + "img/adobe-ae.b605cea9.svg";